module.exports = __webpack_public_path__ + "static/media/the-social-restaurant.eabab8dc.svg";